import { Component, Input } from '@angular/core';
import { GtdNgWidgetComponentAbstract } from 'gtd-ng-widget';
import { RbacPermissionsConstant } from '../../../../../core/services/rbac/rbac-permissions.constant';
import { ProfileResponse } from './profile.response';

@Component({
  selector: 'gtd-widget-affiliate-billing-profile',
  templateUrl: './profile.component.html',
})
export class AffiliateBillingProfileComponent extends GtdNgWidgetComponentAbstract {
  public data: ProfileResponse = new ProfileResponse();
  @Input() id: number;
  @Input() title: string = null;
  @Input() customClass: string;
  protected readonly key: string = 'Invoice\\Profile';
  public RbacPermissionsConstant = RbacPermissionsConstant;
  public paymentDetails: Record<string, any> | null;

  afterData(): void {
    try {
      this.paymentDetails = Object.values(JSON.parse(this.data.payment_details))[0];
    } catch {
      this.paymentDetails = null;
    }
  }
}
